export default __webpack_public_path__ + "static/media/Ballroll_00149.5e89ffa4.png";